import {CorpusMenuService} from '@modules/corpus/core/services/corpus-menu.service';

declare var tarteaucitron: any;
declare global {
    interface Window {
        tarteaucitronForceLanguage: string;
        opera: string;
        _paq: any;
    }
}

import {Platform} from '@angular/cdk/platform';
import {DOCUMENT, NgClass, NgIf} from '@angular/common';
import {} from '@angular/common/http';
import {AfterViewInit, Component, Inject, inject, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {ExtendedModule} from '@angular/flex-layout';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialog, MatDialogConfig, MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {HammerModule, Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {AccountManagementProviderService} from '@modules/account-management';
import {AuthenticationService, UserDataEntity} from '@modules/authentication';
import {AuthorizationService} from '@modules/authorization';
import {BrowserTestService} from '@modules/browser-test';
import {CommunicationCenterService} from '@modules/communication-center';
import {LrsModule} from '@modules/lrs';
import {LangChangeEvent, TranslateModule, TranslateService} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import {Angulartics2GoogleGlobalSiteTag, Angulartics2Matomo} from 'angulartics2';
import {CompassService} from 'fuse-core/compass/compass.service';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from 'fuse-core/components';
import {FuseConfirmDialogComponent} from 'fuse-core/components/confirm-dialog/confirm-dialog.component';
import {MobileRedirectionModalComponent} from 'fuse-core/components/mobile-redirection-modal/mobile-redirection-modal.component';
import {FuseNavigationService} from 'fuse-core/components/navigation/navigation.service';
import {FuseSidebarService} from 'fuse-core/components/sidebar/sidebar.service';
import {NewsModule} from 'fuse-core/news/news.module';
import {SnackbarNewsService} from 'fuse-core/news/snackbar/snackbar-news.service';
import {GlobalConfigurationService} from 'fuse-core/services/global-configuration.service';
import {LayoutConfigService} from 'fuse-core/services/layout-config.service';
import {FuseSplashScreenService} from 'fuse-core/services/splash-screen.service';
import {FuseTranslationLoaderService} from 'fuse-core/services/translation-loader.service';
import {FuseSharedModule} from 'fuse-core/shared.module';
import {FuseNavigation, FuseNavigationItem, LayoutConfig} from 'fuse-core/types';
import {capitalize} from 'lodash-es';
import {OctopusConnectService} from 'octopus-connect';
import {combineLatest, Observable, Subject} from 'rxjs';
import {timer} from 'rxjs/internal/observable/timer';
import {filter, map, mergeMap, startWith, take, takeUntil} from 'rxjs/operators';
import {LanguageService} from 'shared/language.service';
import {GlobalAsyncRules, GlobalSyncRules} from 'shared/models';
import {TypedDataEntityInterface} from 'shared/models/octopus-connect';
import {SharedTranslateModule} from 'shared/shared-translate.module';
import {isMobile} from 'shared/utils/navigator';
import {IsAllowedBySettings} from '../../../../src/app/guards';
import {HorizontalLayout1Module} from '../../../../src/app/layout/horizontal/layout-1/layout-1.module';
import {LayoutModule} from '../../../../src/app/layout/layout.module';
import {VerticalLayout1Module} from '../../../../src/app/layout/vertical/layout-1/layout-1.module';
import {VerticalLayout2Module} from '../../../../src/app/layout/vertical/layout-2/layout-2.module';
import {VerticalLayout3Module} from '../../../../src/app/layout/vertical/layout-3/layout-3.module';

import {DynamicNavigationService} from '../../../../src/app/navigation/dynamic-navigation.service';
import {BdMenuService} from '@modules/bdtool/core/bd-menu.service';
import {
    brand,
    defaultMetaDescription,
    brandTitle,
    defaultLanguage,
    langs,
    GATracking,
    trackingIDFromSettings,
    matomoTrackingIDFromSettings,
    matomoTracking,
    tarteaucitronConf,
    mobileUrlRedirection,
    youTubeTracking,
    twitterTracking,
    isMobileAlert,
    customLayoutConfig,
    accessibiActivate,
    GAdsTracking,
    GTMTracking,
    MetaPixelTracking,
    SnapchatTracking,
    GAdsTrackingIDFromSettings,
    GTMTrackingIDFromSettings,
    MetaPixelTrackingIDFromSettings,
    SnapchatTrackingIDFromSettings, externalUrl, baseAppUrl, defaultApiURL, furtherLinks, enableRgpdLinks,
} from '../../../../src/app/settings/inclusive';
import {TralaTranslationLoaderService} from '../../../../src/app/trala-translation-loader.service';
import {navigation} from 'app/navigation/navigation';
import {TtsModule} from '../../../../src/app/tts/tts.module';
import {ServiceInstantiator} from './service-instantiator.class';
import {GroupsManagementInitializerService} from '@modules/groups-management/core/services/groups-management-initializer.service';
import {AssignationInitializerService} from '@modules/assignation/core/services/assignation-initializer.service';
import {AccessibilityService} from 'fuse-core/services/accessibility.service';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        ExtendedModule,
        FuseProgressBarModule,
        HorizontalLayout1Module,
        NewsModule,
        NgClass,
        NgIf,
        TranslateModule,
        VerticalLayout1Module,
        VerticalLayout2Module,
        VerticalLayout3Module,
        SharedTranslateModule,
        MatMomentDateModule,
        MatExpansionModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatSidenavModule,
        MatDialogModule,
        MatBottomSheetModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        TtsModule,
        LayoutModule,
        LrsModule,
        HammerModule,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
    title = 'inclusive';
    lang: string;
    browserLang: string;
    themeColor = 'red';
    layoutConfig: LayoutConfig;
    navigation: FuseNavigation[];
    public isSnackbarRecallButtonConfigActive = false;
    public isAllowedSkipNavigation = false;
    public brand: string = brand;
    private tarteaucitronConf: object = tarteaucitronConf;
    private brandTitle: string = brandTitle;
    private defaultMetaDescription: any = defaultMetaDescription;
    private trackingID: string = trackingIDFromSettings;
    private matomoTrackingID: string = matomoTrackingIDFromSettings;
    private GAdsTrackingID: string = GAdsTrackingIDFromSettings;
    private GTMTrackingID: string = GTMTrackingIDFromSettings;
    private MetaPixelTrackingID: string = MetaPixelTrackingIDFromSettings;
    private SnapchatTrackingID: string = SnapchatTrackingIDFromSettings;
    private GATracking: boolean = GATracking;
    private matomoTracking: boolean = matomoTracking;
    private youTubeTracking: boolean = youTubeTracking;
    private twitterTracking: boolean = twitterTracking;
    private GAdsTracking: boolean = GAdsTracking;
    private GTMTracking: boolean = GTMTracking;
    private MetaPixelTracking: boolean = MetaPixelTracking;
    private SnapchatTracking: boolean = SnapchatTracking;
    private accessibi = accessibiActivate;
    private _unsubscribeAll: Subject<void>;
    public globalConfigurationService = inject(GlobalConfigurationService);
    private languageService = inject(LanguageService);
    private route = inject(ActivatedRoute);
    private isRouteAccessible = inject(IsAllowedBySettings);
    private trackingInitialized = false;
    private dynamicNavigation = inject(DynamicNavigationService);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);
    private translate = inject(TranslateService);
    private communicationCenter = inject(CommunicationCenterService);
    private authService = inject(AuthenticationService);
    private authorizationService = inject(AuthorizationService);
    private dialog = inject(MatDialog);
    private _layoutConfigService = inject(LayoutConfigService);
    private _fuseNavigationService = inject(FuseNavigationService);
    private _fuseSidebarService = inject(FuseSidebarService);
    private _fuseSplashScreenService = inject(FuseSplashScreenService);
    private _fuseTranslationLoaderService = inject(FuseTranslationLoaderService);
    private _translateService = inject(TranslateService);
    private _platform = inject(Platform);
    private translationLoader = inject(TralaTranslationLoaderService);
    private _serviceInstantiator = inject(ServiceInstantiator);
    private browserTestService = inject(BrowserTestService);
    private matIconRegistry = inject(MatIconRegistry);
    private connector = inject(OctopusConnectService);
    private snackbarNews = inject(SnackbarNewsService);
    private usersProvider = inject(AccountManagementProviderService);
    private titleService = inject(Title);
    private angularticsGA = inject(Angulartics2GoogleGlobalSiteTag);
    private angularticsMatomo = inject(Angulartics2Matomo);
    private renderer = inject(Renderer2);
    private meta = inject(Meta);
    private compassService = inject(CompassService);
    private corpusMenuService = inject(CorpusMenuService); // Inject CorpusMenuService to initialize it
    private groupsInitializer = inject(GroupsManagementInitializerService);
    private bdMenuService = inject(BdMenuService);
    private assignationInitService = inject(AssignationInitializerService);
    private accessibilityService = inject(AccessibilityService)


    /**
     * Constructor
     */
    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {
        this._unsubscribeAll = new Subject<void>();
        this.initNavigation();
        this.initLangManagement();
        this.initMobilePlatformManagement();
        this.initLayoutConfigManagement();
        this.assignationInitService.initialize();
        this.corpusMenuService.initialize();
        this.groupsInitializer.initialize();
        // add default meta description if exists
        if (this.defaultMetaDescription && this.defaultMetaDescription[this._translateService.currentLang]) {
            this.meta.addTag({
                name: 'description',
                content: this.defaultMetaDescription[this._translateService.currentLang]
            });
        }

        this.communicationCenter
            .getRoom('authentication')
            .getSubject('userData')
            .subscribe((data) => {
                if (data) {
                    Sentry.setUser({email: data.get('email')});
                    !this.trackingInitialized ? this.initTracking() : null;
                    this.postAuthentication();
                } else {
                    !this.trackingInitialized ? this.initTracking() : null;
                    this.postLogout();
                }
            });

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                filter((route) => route.outlet === 'primary'),
                mergeMap((route) => {
                    if (route.data) {
                        return route.data;
                    } else {
                        return null;
                    }
                })
            )
            .subscribe((evt) => {
                let menuId: string;

                if (evt && evt['menu']) {
                    menuId = evt['menu'];
                } else {
                    menuId = 'level0';
                }
                this.registerDefaultLinkWithoutAuthentication();
                this.dynamicNavigation.generateMenu(menuId);
                this.dynamicNavigation.switchClassPath(menuId);
            });

        /** CONFIG plateforme Inclusive **/
        this.compassService.isSearchActive = true;
    }

    ngOnInit(): void {
        this.accessibilityService.init();
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                // if in whitelist array and is not authenticated
                if (!this.authService.isAuthenticated) {
                    const whiteListUrls = ['login', 'register', 'forgot-password'];
                    for (let i = 0; i < whiteListUrls.length; i++) {
                        if (window.location.href.indexOf(whiteListUrls[i]) > -1) {
                            !this.trackingInitialized ? this.initTracking() : null;
                        }
                    }
                }
            });

        this.document.body.classList.add(this.brand);
        this.document.querySelector<HTMLLinkElement>('link[ rel *= "icon"]').href =
            'assets/' + this.brand + '/favicon.png?v=6';
        this.setTitle(this.brandTitle);
        // Subscribe to config changes
        this._layoutConfigService.config$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.layoutConfig = config;

                if (this.layoutConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                } else {
                    this.document.body.classList.remove('boxed');
                }
            });

        requestIdleCallback(() => {
            this.browserTestService.checkCompatibility();
        });

        // La vérification initiale de l'authentification et la gestion de l'état
        // (y compris l'erreur 401 initiale) sont maintenant entièrement gérées
        // par AuthenticationService.
        // AppComponent réagit aux changements d'état via son abonnement
        // au 'userData' et 'doLogout' du communicationCenter (voir lignes 167-178).
        // La suppression de ce bloc évite un appel /users/me redondant.
    }

    ngAfterViewInit(): void {
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    public setTitle(newTitle: string): void {
        this.titleService.setTitle(newTitle);
    }

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    loadGoogleAnalytics(trackingID: string): void {
        const gaScript = document.createElement('script');
        gaScript.setAttribute('async', 'true');
        gaScript.setAttribute(
            'src',
            `https://www.googletagmanager.com/gtag/js?id=${trackingID}`
        );

        const gaScript2 = document.createElement('script');
        gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\', {'anonymize_ip': true, 'cookie_expires': 33696000});`;

        document.documentElement.firstChild.appendChild(gaScript);
        document.documentElement.firstChild.appendChild(gaScript2);
    }

    loadMatomo(trackingID: string): void {
        const matomoScript = document.createElement('script');
        matomoScript.setAttribute('type', `text/javascript`);
        matomoScript.innerText = `var _paq = window._paq || [];_paq.push([\'enableLinkTracking\']);(function() {var u=\'https://matomo.tralalere.com/\';_paq.push([\'setTrackerUrl\', u+\'matomo.php\']);_paq.push([\'setSiteId\', \'${trackingID}\']);var d=document, g=d.createElement(\'script\'), s=d.getElementsByTagName(\'script\')[0];g.type=\'text/javascript\'; g.async=true; g.defer=true; g.src=u+\'matomo.js\'; s.parentNode.insertBefore(g,s);})();`;
        document.documentElement.firstChild.appendChild(matomoScript);
    }

    loadTartaucitron(): HTMLScriptElement {
        const tarteaucitronScript = document.createElement('script');
        tarteaucitronScript.setAttribute(
            'src',
            `https://www.tralalere.com/header/tarteaucitron/gcmv2/tarteaucitron.min.js`
        );
        this.renderer.appendChild(document.body, tarteaucitronScript);
        return tarteaucitronScript;
    }

    tarteaucitronInit(): void {
        window.tarteaucitronForceLanguage = this._translateService.currentLang;
        tarteaucitron.init(this.tarteaucitronConf);
        // Google analytics
        if (this.GATracking) {
            tarteaucitron.user.gtagUa = this.trackingID;
            // tarteaucitron.user.gtagCrossdomain = ['example.com', 'example2.com'];
            tarteaucitron.user.gtagMore = function (): void {
                /* add here your optionnal gtag() */
            };
            (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
        }

        // matomo
        /* // remove from tarteaucitron to force matomo tracking
        if (this.matomoTracking) {
            tarteaucitron.user.matomoId = this.matomoTrackingID;
            tarteaucitron.user.matomoHost = 'https://matomo.tralalere.com/';
            (tarteaucitron.job = tarteaucitron.job || []).push('matomo');
        } */

        // youtube
        if (this.youTubeTracking) {
            (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
        }

        // twitter
        if (this.twitterTracking) {
            (tarteaucitron.job = tarteaucitron.job || []).push('twitterembed');
        }

        // GAds
        if (this.GAdsTracking) {
            tarteaucitron.user.googleadsId = this.GAdsTrackingID;
            (tarteaucitron.job = tarteaucitron.job || []).push('googleads');
        }

        // GTM
        if (this.GTMTracking) {
            tarteaucitron.user.googletagmanagerId = this.GTMTrackingID;
            (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
        }

        // Meta Pixel
        if (this.MetaPixelTracking) {
            tarteaucitron.user.facebookpixelId = this.MetaPixelTrackingID;
            tarteaucitron.user.facebookpixelMore = function () { /* add here your optionnal facebook pixel function */
            };
            (tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');
        }

        // Snapchat
        if (this.SnapchatTracking) {
            tarteaucitron.user.snapchatId = this.SnapchatTrackingID;
            tarteaucitron.user.snapchatEmail = '__INSERT_USER_EMAIL__';
            (tarteaucitron.job = tarteaucitron.job || []).push('snapchat');
        }

        //GCMv2
        if (this.GTMTracking || this.GAdsTracking || this.GATracking) {
            (tarteaucitron.job = tarteaucitron.job || []).push('gcmadstorage');
            (tarteaucitron.job = tarteaucitron.job || []).push('gcmanalyticsstorage');
            (tarteaucitron.job = tarteaucitron.job || []).push('gcmfunctionality');
            (tarteaucitron.job = tarteaucitron.job || []).push('gcmpersonalization');
            (tarteaucitron.job = tarteaucitron.job || []).push('gcmadsuserdata');
            (tarteaucitron.job = tarteaucitron.job || []).push('gcmsecurity');
        }

        this.trackingInitialized = true;
    }

    navigateToAnchor(event: Event) {
        event.preventDefault();
        const anchorId = 'maincontent';
        const element = document.getElementById(anchorId);

        if (element) {
            element.focus();
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

    private initLayoutConfigManagement(): void {
        if (customLayoutConfig.hasOwnProperty('default')) {
            if (customLayoutConfig.hasOwnProperty(this.authService.accessLevel)) {
                this._layoutConfigService.setConfig(customLayoutConfig[this.authService.accessLevel], {emitEvent: true});
            } else {
                this._layoutConfigService.setConfig(customLayoutConfig['default'], {emitEvent: true});
            }

            this.communicationCenter
                .getRoom('authentication')
                .getSubject('userData')
                .subscribe(userData => {
                    const role = this.authService.accessLevel;
                    if (customLayoutConfig.hasOwnProperty(role)) {
                        this._layoutConfigService.setConfig(customLayoutConfig[role], {emitEvent: true});
                    } else {
                        this._layoutConfigService.setConfig(customLayoutConfig['default'], {emitEvent: true});
                    }
                });
        }
    }


    private initMobilePlatformManagement(): void {
        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }
    }

    private initTracking(): void {

        // cookies managment with tarteaucitron
        if ((this.youTubeTracking
                || this.twitterTracking
                || this.GATracking
                || this.GAdsTracking
                || this.GTMTracking
                || this.MetaPixelTracking
                || this.SnapchatTracking)
            && !this.authService.isGAR()
        ) {
            this.loadTartaucitron().onload = () => {
                this.tarteaucitronInit();
            };
        }

        // Matomo tracking
        if (this.matomoTracking) {
            this.loadMatomo(this.matomoTrackingID);
            this.angularticsMatomo.startTracking();
        }

        // Google Analytics tracking
        if (this.GATracking) {
            this.angularticsGA.startTracking();
        }
    }

    private initLangManagement(): void {
        if (this.globalConfigurationService.getUseSelectedLangAsDefault()) {
            const defaultLang: string[] = langs.map((lang) => lang.id);
            this.browserLang =
                defaultLang.indexOf(navigator.language.substring(0, 2)) !== -1
                    ? navigator.language.substring(0, 2)
                    : defaultLanguage;

            // Add languages
            this._translateService.addLangs(defaultLang);

            // Set the default language
            this._translateService.setDefaultLang(this.browserLang);

            // Use a language
            this.lang = localStorage.getItem('lang') || this.browserLang;
            this.document.documentElement.lang = this.lang;
            this.connector.setLanguage(this.lang);
            this._translateService.use(this.lang);
            // Set the navigation translations
            this.translationLoader.loadTranslations(...defaultLang);
        } else {
            const lang = this.languageService.getActiveLanguage().id;
            this.document.documentElement.lang = lang;
            this.connector.setLanguage(lang);
            // Set the navigation translations
            this.translationLoader.loadTranslations(...this.languageService.availableLanguages.map((lang) => lang.id));
        }

        this._translateService.onLangChange.subscribe(
            (event: LangChangeEvent) => {
                this.connector.setLanguage(event.lang);
                this.document.documentElement.lang = event.lang;
                this._translateService.currentLang = event.lang;
                // init tarteaucitron and update tarteaucitron language
                if (
                    this.youTubeTracking ||
                    this.twitterTracking ||
                    this.GATracking
                ) {
                    this.tarteaucitronInit();
                }
            }
        );
        if (this.globalConfigurationService.getsubscribeToLanguageChange()) {
            this.checkIfQueryParamsForceLanguage();
            this.languageService.onLanguageChange$.subscribe((lang) => {
                // Update dynamic menu with new language
                this.dynamicNavigation.generateMenu(this.dynamicNavigation.currentMenuId, true);
                // check route with access settings for new language
                this.isRouteAccessible.checkRouteAllowedOrRedirect(this.route.snapshot, this.router.routerState.snapshot);
            });
        }
    }

    private initNavigation(): void {
        // Get default navigation
        this.navigation = navigation;

        // Register the navigation to the service
        this._fuseNavigationService.register('main', []);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const slugs = event.url.split('/').slice(1);

                const title = slugs
                    .map((slug) => `${capitalize(slug.split('?')[0])}`)
                    .join(' - ');
                this.setTitle(`${this.brandTitle} | ${title}`);
                this.isAllowedSkipNavigation = !(event.url.includes('register') || event.url.includes('login') || event.url.includes('password'));
            });
    }

    private postAuthentication(): void {
        this.isSnackbarRecallButtonConfigActive = this.snackbarNews.isRecallButtonActive;

        timer(1000).subscribe(() => {
            // isMobileAlert is used to show a msg mobile not supported but without redirection
            if (isMobile() && (mobileUrlRedirection || isMobileAlert)) {
                const dialogRef = this.dialog.open(
                    MobileRedirectionModalComponent,
                    {}
                );
                dialogRef.afterClosed().subscribe((result) => {
                    // isMobileAlert => no redirection only alert
                    if (result && !isMobileAlert) {
                        window.location.href = mobileUrlRedirection;
                    }
                });
            }
        });

        if (this.authService.isGAR()) {
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'access-adventure',
                title: 'access adventure',
                translate: 'navigation.access_adventure',
                type: 'item',
                icon: 'code_sand_box',
                url: 'page/aventure',
                externalUrl: false,
                openInNewTab: false,
                displayIcon: true,
            });
        }

        this.handleFurtherMenu();
        this.handleFurtherLinksAtRoot();
        this.registerDefaultLinkWithoutAuthentication();
        this.handleEducationalResourcesMenu();

        if (this.authService.isGAR()) {
            this.dynamicNavigation.clearMenuItem('level0', 'access-future-engineer');
        }


        if (this.authService.hasLevel(['learner', 'parent', 'trainer', 'manager', 'administrator'])) {
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'home',
                title: 'Home',
                translate: 'navigation.home',
                type: 'item',
                icon: 'home',
                url: '/home',
            });
        }

        if (this.authService.hasLevel(['trainer', 'manager', 'administrator'])) {
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'needhelp',
                title: 'Need help',
                translate: 'navigation.needhelp',
                type: 'link',
                icon: 'help',
                url: '/',
            });

            this.updateHelpLink();

            // boussole as faq component
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'faq',
                title: 'faq',
                translate: 'generic.faq',
                type: 'item',
                icon: 'compass',
                url: '/faq',
            });

            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'boussole',
                title: 'boussole',
                translate: 'generic.compass',
                type: 'item',
                icon: 'compass',
                url: '/boussole',
            });

            // boussole as rise360 export
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'faq',
                title: 'faq',
                translate: 'generic.faq',
                type: 'item',
                icon: 'compass',
                url: `${defaultApiURL}interactive/boussole/`,
                externalUrl: true,
                openInNewTab: false,
                displayIcon: true,
                function: (event, item) => this.askConsent(event, item)
            });

            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'funambuleMove',
                title: 'Manoeuvre du funambule',
                translate: 'funambule.move',
                type: 'item',
                icon: 'funambule',
                url: '/page/manoeuvre-funambule',
            });

            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'virtualClass',
                title: 'Classe virtuelle',
                translate: 'virtual.class',
                type: 'item',
                icon: 'virtual_class',
                url: '/page/classe-virtuelle',
            });

            this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
                this.updateHelpLink();
            });
        } else if (this.authService.hasLevel(['learner'])) {
            this.updateHelpLink('_learner');
            this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
                this.updateHelpLink('_learner');
            });
        }

        if (this.authorizationService.currentUserCan<boolean>(GlobalSyncRules.accessToEducationalSheetsAsCards, false)) {
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'educational-sheets-as-cards',
                title: 'global.educational-sheets-as-cards',
                translate: 'global.educational-sheets-as-cards',
                type: 'item',
                icon: 'book',
                url: 'page-as-card-list/educational-sheets-list',
            });
        }

        this.dynamicNavigation.clearMenuItem('level0', 'help_anonymous');
    }

    private postLogout(): void {
        this.isSnackbarRecallButtonConfigActive = false;
        this.registerDefaultLinkWithoutAuthentication();
        this.dynamicNavigation.clearMenuItem(
            'level0',
            'external-target-link-menu'
        );
        this.dynamicNavigation.clearMenuItem('level0', 'home');
        this.dynamicNavigation.clearMenuItem('level0', 'needhelp');
        this.dynamicNavigation.clearMenuItem('level0', 'funambuleMove');
        this.dynamicNavigation.clearMenuItem('level0', 'virtualClass');
        this.dynamicNavigation.clearMenuItem('level0', 'boussole');
        this.dynamicNavigation.clearMenuItem('level0', 'faq');
        this.dynamicNavigation.clearMenuItem('level0', 'educational-sheets-as-cards');
        this.dynamicNavigation.clearMenuItem('level0', 'educational_resources');
        this.dynamicNavigation.clearMenuItem('level0', 'forFurther');
        this.dynamicNavigation.clearMenuItem('level0', 'informations-legales');
        this.dynamicNavigation.clearMenuItem('level0', 'qui-sommes-nous');
        furtherLinks.forEach(l => this.dynamicNavigation.clearMenuItem('level0', 'root_' + l.label));
        if (!enableRgpdLinks) {
            this.dynamicNavigation.clearMenuItem('level0', 'mentions-legales');
            this.dynamicNavigation.clearMenuItem('level0', 'cgurgpd');
            this.dynamicNavigation.clearMenuItem(
                'level0',
                'politique-confidentialite'
            );
            this.dynamicNavigation.clearMenuItem('level0', 'accessibility');
            this.addHelpAnonymous();
        }
    }


    private checkIfQueryParamsForceLanguage(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            const queryParams = this.router.parseUrl(this.router.url).queryParams;
            const suggestedLanguageId = queryParams && queryParams['SuggestedLanguage'];

            // if there is no our query param, we don't need to do anything
            if (!suggestedLanguageId) {
                return;
            }
            const suggestedLanguage = this.languageService.availableLanguages.find(lang => lang.id === suggestedLanguageId);

            // if the language is already set, we don't need to do anything
            if (this.languageService.getActiveLanguage() === suggestedLanguage) {
                return;
            }
            this.languageService.setActiveLanguage(suggestedLanguage);

            // and now we remove the suggested language from the query params
            this.router.navigate([], {
                queryParams: {...queryParams, SuggestedLanguage: null},
                queryParamsHandling: 'merge'
            });
        });
    }

    private registerDefaultLinkWithoutAuthentication(): void {
        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'legalnotice',
            classes: 'legalnotice',
            title: 'Mentions légales',
            translate: 'navigation.legalnotice',
            type: 'item',
            icon: 'new_releases',
            url: '/page/conditions-generales',
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'privacy',
            classes: 'privacy',
            title: 'Privacy',
            translate: 'navigation.privacy',
            type: 'link',
            icon: 'shield',
            url: '/page/privacy',
        });
        this.addHelpAnonymous();
        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'needhelp',
            classes: 'needhelp',
            title: 'Need help',
            translate: 'navigation.needhelp',
            type: 'link',
            icon: 'help',
            url: '/',
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'how-to',
            title: 'how-to',
            translate: 'navigation.how-to',
            type: 'item',
            icon: 'idea',
            url: '/page/comment-ca-marche',
            displayIcon: true,
        });

        if (!this.authService.isGAR()) {
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'access-future-engineer',
                title: 'access future engineer',
                translate: 'navigation.access_future_engineer',
                type: 'item',
                icon: 'access-future-engineer',
                url: externalUrl && externalUrl['access-future-engineer'],
                externalUrl: externalUrl && !!externalUrl['access-future-engineer'],
                openInNewTab: externalUrl && !!externalUrl['access-future-engineer'],
                displayIcon: true,
            });
        }

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'external-url',
            title: 'navigate to external url',
            translate: this.authService.isLearner() ? 'navigation.external-url-learner' : 'navigation.external-url',
            type: 'item',
            url: `${baseAppUrl}#/session?token=${localStorage
                .getItem('http_accessToken')
                ?.slice(1, -1)}&redirectPath=lessons/home`,
            externalUrl: true,
            openInNewTab: false,
            displayIcon: false,
            function: (event, item) => this.askConsent(event, item)
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'contact-us',
            title: 'contact us',
            translate: 'navigation.contact_us',
            type: 'item',
            icon: 'contact-us',
            url: this.urlFromSettings('contact-us').url,
            externalUrl: this.urlFromSettings('contact-us').isExternalUrl,
            openInNewTab: this.urlFromSettings('contact-us').isExternalUrl,
            displayIcon: true,
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'mentions-legales',
            title: 'mentions-legales',
            translate: 'navigation.legalnotice',
            type: 'item',
            icon: 'visibility_legalnotice',
            url: this.urlFromSettings('mentions-legales').url,
            displayIcon: true,
            externalUrl: this.urlFromSettings('mentions-legales').isExternalUrl,
            openInNewTab: this.urlFromSettings('mentions-legales').isExternalUrl,
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'informations-legales',
            title: 'informations-legales',
            classes: 'legalnotice',
            translate: 'navigation.legal_notice',
            type: 'item',
            icon: 'policy-rounded-fill',
            url: '/informations-legales',
            displayIcon: true,
            externalUrl: false,
            openInNewTab: false,
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'qui-sommes-nous',
            title: 'qui-sommes-nous',
            classes: 'legalnotice',
            translate: 'navigation.who_are_we',
            type: 'item',
            icon: 'who_are_we',
            url: '/page/qui-sommes-nous',
            displayIcon: true,
            externalUrl: false,
            openInNewTab: false,
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'cgurgpd',
            classes: 'cgurgpd',
            title: 'cgurgpd',
            translate: 'navigation.cgurgpd',
            type: 'item',
            icon: 'visibility_cgurgpd',
            url: this.urlFromSettings('cgurgpd').url,
            displayIcon: true,
            externalUrl: this.urlFromSettings('cgurgpd').isExternalUrl,
            openInNewTab: this.urlFromSettings('cgurgpd').isExternalUrl,
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'accessibility',
            classes: 'accessibility',
            title: 'accessibility',
            translate: 'navigation.accessibility',
            type: 'item',
            icon: 'accessibility',
            url: '/page/accessibilite',
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'contact',
            classes: 'contact',
            title: 'contact',
            translate: 'navigation.contact',
            type: 'item',
            icon: 'help',
            url: this.urlFromSettings('contact').url,
            externalUrl: this.urlFromSettings('contact').isExternalUrl,
            openInNewTab: this.urlFromSettings('contact').isExternalUrl,
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'feedback',
            classes: 'contact',
            title: 'contact',
            translate: 'navigation.contact',
            type: 'item',
            icon: 'feedback',
            url: this.authService.isGAR() ? '/page/feedback-gar' : '/page/feedback',
        });


        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'politique-confidentialite',
            classes: 'politique-confidentialite',
            title: 'politique-confidentialite',
            translate: 'navigation.privacy',
            type: 'item',
            icon: 'visibility_privacy',
            url: this.urlFromSettings('politique-confidentialite').url,
            displayIcon: true,
            externalUrl: this.urlFromSettings('politique-confidentialite').isExternalUrl,
            openInNewTab: this.urlFromSettings('politique-confidentialite').isExternalUrl,
        });

        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'site-map',
            title: 'site map',
            translate: 'navigation.site_map',
            type: 'item',
            icon: 'site_map',
            url: this.siteMapUrlByRole(),
            externalUrl: false,
            openInNewTab: false,
            displayIcon: true,
        });
    }

    siteMapUrlByRole(): string {
        if (this.authService.accessLevel !== 'anonymous') {
            return 'page/site-map-' + this.authService.accessLevel;
        } else {
            return 'page/site-map';
        }
    }

    /**
     * Replace help link with appropriate url
     */
    private updateHelpLink(Urlsuffix = ''): void {
        this.dynamicNavigation.clearMenuItem('level0', 'needhelp');
        this.translate
            .get('navigation.needhelp_url' + Urlsuffix)
            .subscribe((url: string) => {
                this.dynamicNavigation.refreshModuleMenu('level0', {
                    id: 'needhelp',
                    title: 'Need help',
                    translate: 'navigation.needhelp',
                    type: 'link',
                    icon: 'help',
                    url: url,
                });
            });
    }

    private getFurtherChildLinks(): FuseNavigationItem[] {
        return [
            {
                id: 'gameCodeList',
                title: 'gameCodeList',
                translate: 'generic.game_code_title',
                type: 'item',
                url: '/code/gamecode/list',
            },
            {
                id: 'gleamCodeList',
                title: 'gleamCodeList',
                translate: 'generic.gleam_code_title',
                type: 'item',
                url: '/code/gleamcode/list',
            },
            {
                id: 'brume',
                classes: 'brume',
                title: 'brume',
                translate: 'navigation.brume',
                type: 'item',
                url: '/collection/brume',
            },
            {
                id: 'activities',
                title: 'activities',
                translate: 'activities.title',
                type: 'item',
                url: '/activities/list'
            },
            {
                id: 'faq',
                title: 'faq',
                translate: 'generic.faq',
                type: 'item',
                icon: 'compass',
                url: '/faq',
            },
            {
                id: 'boussole',
                title: 'boussole',
                translate: 'generic.compass',
                type: 'item',
                icon: 'compass',
                url: '/boussole',
            },
            {
                id: 'external-dictionary',
                title: 'navigate to external url',
                translate: 'navigation.external-url-dictionary',
                type: 'item',
                url: `${baseAppUrl}#/session?token=${localStorage
                    .getItem('http_accessToken')
                    ?.slice(1, -1)}&redirectPath=activities/dictionary`,
                externalUrl: true,
                openInNewTab: false,
                displayIcon: false,
                function: (event, item) => this.askConsent(event, item)
            },
            {
                id: 'external-language-lab',
                title: 'navigate to external url',
                translate: 'navigation.external-language-lab',
                type: 'item',
                url: `${baseAppUrl}#/session?token=${localStorage
                    .getItem('http_accessToken')
                    ?.slice(1, -1)}&redirectPath=activities/language-lab`,
                externalUrl: true,
                openInNewTab: false,
                displayIcon: false,
                function: (event, item) => this.askConsent(event, item)
            },
            ...this.getFurtherChildLinksFromSettings()
        ];
    }

    private askConsent($event, item): void {
        $event.preventDefault();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            bodyDialog: 'activities.redirect_' + this.authService.accessLevel + '_to_app',
            labelTrueDialog: 'generic.confirm',
            labelFalseDialog: 'generic.cancel'
        };

        for (const term in dialogConfig.data) {
            this.translate.get(dialogConfig.data[term]).subscribe((translation: string) => dialogConfig.data[term] = translation);
        }

        const modalRef = this.dialog.open(FuseConfirmDialogComponent, dialogConfig);
        modalRef.afterClosed().subscribe(result => {
            if (result === true) {
                window.open(item.url, item.openInNewTab ? '_blank' : '_self'); // Redirige l'utilisateur si le résultat est true
            }
        });
    }

    /**
     * Add link to helper resources just for unlogged user
     * @private
     */
    private addHelpAnonymous(): void {
        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'help_anonymous',
            title: 'help',
            translate: 'navigation.general_help',
            type: 'item',
            icon: 'help',
            url: '/page/aide-aux-ressources',
        });
    }

    private urlFromSettings(id: string): { url: string, isExternalUrl: boolean } {
        const urls = {
            'cgurgpd': '/page/cgurgpd',
            'mentions-legales': '/page/mentions-legales',
            'politique-confidentialite': '/page/politique-confidentialite',
            'contact': '/feedback', // default value
        };

        const garUrls = {
            'cgurgpd': '/page/cgurgpd-gar',
            'mentions-legales': '/page/mentions-legales-gar',
            'politique-confidentialite': '/page/politique-confidentialite-gar',
            'contact-us': '/page/contact-us',
            'contact': '/feedback', // default value
        };

        const sapiensUrls = {
            'contact': 'https://unstoppable-us.com/contact', // contact for sapiens is an external website
        };

        if (this.authService.isGAR()) {
            if (garUrls[id]) {
                return {url: garUrls[id], isExternalUrl: false};
            }
        } else if (this.brand.toString() === 'sapiens' && sapiensUrls[id]) {
            return {url: sapiensUrls[id], isExternalUrl: true};
        } else if (urls[id]) {
            return {url: urls[id], isExternalUrl: false};
        }

        if (externalUrl && externalUrl[id]) {
            return {url: externalUrl[id], isExternalUrl: true};
        }

        return {url: '', isExternalUrl: undefined};
    }

    private getFurtherChildLinksFromSettings(): FuseNavigationItem[] {
        return furtherLinks.map(l => (
            {
                id: 'further_' + l.label,
                classes: l.label,
                title: l.label,
                translate: 'navigation.' + l.label,
                type: 'item',
                url: l.url,
            }
        ));
    }

    private handleFurtherMenu() {
        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'forFurther',
            title: 'Pour aller plus loin',
            translate: 'generic.for_further',
            type: 'collapse',
            icon: 'for_further',
            children: this.getFurtherChildLinks(),
        });
    }

    private handleEducationalResourcesMenu() {
        this.dynamicNavigation.refreshModuleMenu('level0', {
            id: 'educational_resources',
            title: 'Ressources pédagogiques',
            translate: 'generic.educational_resources',
            type: 'collapse',
            icon: 'educational-resources',
            children: [
                {
                    id: 'ressources_humanum',
                    classes: 'ressources_humanum',
                    title: 'ressources_humanum',
                    translate: 'navigation.ressources_humanum',
                    type: 'item',
                    url: '/further/ressources-partenaires-ilove',
                },
                {
                    id: 'ressources_supplementaires',
                    classes: 'ressources_supplementaires',
                    title: 'ressources_supplementaires',
                    translate: 'navigation.ressources_supplementaires',
                    type: 'item',
                    url: '/further/ressources-supplementaires',
                }
            ],
        });
    }

    private handleFurtherLinksAtRoot() {
        furtherLinks.forEach(l => {
            this.dynamicNavigation.refreshModuleMenu('level0', {
                id: 'root_' + l.label,
                title: l.label,
                translate: 'navigation.' + l.label,
                type: 'item',
                url: l.url,
            });
        });
    }
}
